// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4112":"a3ede44e6a0beb25","5540":"0241cdfd9f0b285c","8437":"6aaf9734d6326919","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};